import { actionTypes } from "../actions/types";

const EventsReducer = (state = [], action) => {
  switch (action.type) {
    case actionTypes.FETCH_EVENTS:
      return action.payload;
    case actionTypes.CREATE_EVENT: // just pass in the newly created row (have that returned from the api)
      return [...state.concat(action.payload)];
    case actionTypes.EDIT_EVENT:
      const updatedEvent = state.map((item) => {
        if (item.event_id === action.payload.event_id) {
          return { ...item, ...action.payload };
        }
        return item;
      });
      return updatedEvent;
    case actionTypes.DELETE_EVENT:
      return [...state.filter((item) => item.event_id !== action.payload)];
    default:
      return state;
  }
};

export default EventsReducer;
